import { CustomerPortalService } from "@adfenix/types";
import { DataEvent } from "@adfenix/ui-events";
import { SERVICES_URL, handleError } from "api/helper";
import { request, post } from "api/http";
import { getIdToken } from "lib/amplify/getIdToken";

const postPublic = request("POST", false);

const publicUrl = `${SERVICES_URL}/customer-portal/public/v1/user-events`;
const authUrl = `${SERVICES_URL}/customer-portal/auth/v1/user-events`;

/**
 * If the user is not signed in we should send the events to the public endpoint
 */
export const sendUserEvents = async (events: DataEvent[]): Promise<void> => {
  if (process.env.NODE_ENV === "development") {
    return Promise.resolve();
  }

  const token = await getIdToken();

  if (token) {
    return post(`${authUrl}`, events);
  }

  return postPublic(`${publicUrl}`, events);
};

export const sendIntegrationRequest = ({
  integrationFormState
}: {
  integrationFormState: CustomerPortalService.IntegrationRequest;
}) => {
  return post(
    `${SERVICES_URL}/customer-portal/auth/v1/integration-request`,
    integrationFormState
  ).catch(handleError);
};

// Just create a closure that takes in the fetch function and returns an object with request methods
